import { createZodDto } from "nestjs-zod/dto";
import z from "zod";
import { userSchema } from "../user";

export const fidelityAccountSchema = z.object({
  id: z.string(),
  userId: z.string(),
  user: userSchema.optional(),
  updateAt: z.coerce.date(),
  balance: z.number(),
});

export class FidelityAccountDto extends createZodDto(fidelityAccountSchema) {}
